import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatProgressBar } from '@angular/material/progress-bar';

@Component({
  selector: 'dss-libs-ui-progress-bar',
  imports: [MatProgressBar],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  /*
   * The ratio of the progress bar to fill.
   * Should be between 0 and 1.
   */
  readonly fillRatio = input.required<number>();

  /*
   * The threshold value at which the progress bar will switch to the warning color if exceeded.
   * Warning state is never triggered unless explicitly set.
   * Should be between 0 and 1
   */
  readonly warningThresholdRatio = input<number>(Infinity);

  readonly fillPercentage = computed(() => this.fillRatio() * 100);

  readonly color = computed<'primary' | 'warn'>(() =>
    this.fillRatio() >= this.warningThresholdRatio() ? 'warn' : 'primary'
  );
}
